import { AuthProvider } from "react-oidc-context";

import { oidcConfig } from "../hooks/OidcConfig";

export const AuthWrapper = ({ children }: { children: React.ReactNode }) => {
  const isSSO = import.meta.env.VITE_SSO === "true";

  return isSSO ? (
    <AuthProvider {...oidcConfig}>{children}</AuthProvider>
  ) : (
    <>{children}</>
  );
};
